import { useCallback, useMemo } from 'react';
import { useDisclosure } from '@/hooks/useDisclosure';
import { SelectPrefectureDialog } from './SelectPrefectureDialog';
import { PrefectureValue } from '@/constants/prefectures';

export interface UseSelectPrefectureDialogProps {
  value: PrefectureValue | undefined;
  onValueChange: (value?: PrefectureValue) => void;
}

export function useSelectPrefectureDialog({
  value,
  onValueChange,
}: UseSelectPrefectureDialogProps) {
  const { isOpen, onClose, onOpen, onOpenChange } = useDisclosure();

  const handleValueChange = useCallback(
    (value: string) => {
      onValueChange(value as PrefectureValue);
      onClose();
    },
    [onValueChange, onClose]
  );

  const handleClickClear = useCallback(() => {
    onValueChange();
    onClose();
  }, [onValueChange, onClose]);

  return useMemo(
    () => ({
      isOpen,
      value,
      onOpen,
      onOpenChange,
      onClose,
      Dialog: (
        <SelectPrefectureDialog
          isOpen={isOpen}
          isEnableClear={!!value}
          value={value}
          onOpenChange={(value) => onOpenChange(value)}
          onValueChange={handleValueChange}
          onClickClear={handleClickClear}
        />
      ),
    }),
    [isOpen, value, handleValueChange, handleClickClear, onOpenChange]
  );
}
